module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "radio",
      "name": _vm.name,
      "id": _vm.vaId,
      "disabled": _vm.isDisabled
    },
    domProps: {
      "value": _vm.value,
      "checked": _vm.isChecked
    }
  }), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a0629016!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VARadio.vue
// module id = 534
// module chunks = 1